
export enum InvoiceProvider {
  Billingo = 'billingo',
  Szamlazz = 'szamlazz',
}
